import { Component, OnInit, Input } from '@angular/core';
import { SearchCondition } from 'src/app/shared/model/search-condition.model';
import { PageEnums } from 'src/app/shared/enum/page-enums';
@Component({
  selector: 'app-item-gross-margin',
  templateUrl: './gross-margin.component.html',
  styleUrls: ['./gross-margin.component.scss']
})
export class GrossMarginComponent implements OnInit {
  @Input() searchParams: SearchCondition;
  @Input() open: boolean;
  @Input() page: string;
  constructor() {}
  showGrossMargin: boolean = false;
  atWorkerPage: boolean = false;

  ngOnInit() {
    this.showGrossMargin = ([
      PageEnums.worker_detail,
      PageEnums.project_detail
    ] as string[]).includes(this.page);
    this.atWorkerPage = PageEnums.worker_detail == this.page;
  }
}
